(function (){
    'use strict';

    const injectModules = [
        'materialConfig',
        'ngCookies',
        'ngPassword',
        'ui.mask',
        'authAppController'
    ]

    angular.module('authApp', injectModules).config(['$mdThemingProvider', authAppConfig]);

    function authAppConfig ($mdThemingProvider) {
        $mdThemingProvider
            .theme('default')
            .primaryPalette('purple', {
                'default': '600',
                'hue-1': '200',
                'hue-2': '300',
                'hue-3': '800',
            });
    }
})();
